import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Chip,
} from "@mui/material";
import Iconify from "../iconify/Iconify";

export default function FeatureLockedDialog({
  open,
  onClose,
  onUpgrade,
  upgradePlanLabel,
  memberView,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Iconify icon="mdi:lock-outline" width={22} />
          <Typography variant="h6">Funktion nicht verfügbar</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        {memberView ? (
          <Typography variant="body1">
            Diese Funktion steht für Ihren Zugang nicht zur Verfügung. Bitte
            wenden Sie sich an Ihren Administrator.
          </Typography>
        ) : (
          <>
            <Typography variant="body1" sx={{ mb: 1.5 }}>
              Dieses Feature ist in deinem Tarif nicht verfügbar. Upgrade hier,
              um diese Funktion zu nutzen.
            </Typography>
            {upgradePlanLabel && (
              <Chip
                color="info"
                icon={<Iconify icon="mdi:rocket-launch-outline" width={16} />}
                label={`Empfohlenes Upgrade: ${upgradePlanLabel}`}
                size="small"
              />
            )}
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        {!memberView && (
          <Button variant="contained" onClick={onUpgrade}>
            Jetzt upgraden
          </Button>
        )}
        <Button onClick={onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
}

FeatureLockedDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onUpgrade: PropTypes.func,
  upgradePlanLabel: PropTypes.string,
  memberView: PropTypes.bool,
};

FeatureLockedDialog.defaultProps = {
  open: false,
  upgradePlanLabel: "",
  memberView: false,
  onUpgrade: () => {},
};
